export const AREA_NOT_FOUND = 'area.not_found';
